import {
  GET_LEGAL_SUITABILITY,
  GET_LEGAL_SUITABILITY_ERROR,
  GET_LEGAL_SUITABILITY_SUCCESS,
  GET_START_DATE_ACTIVITY,
  GET_START_DATE_ACTIVITY_ERROR,
  GET_START_DATE_ACTIVITY_SUCCESS
} from './LegalSuitabilitySection.actions'

const legalSuitabilityState = {
  dni: '',
  creationDate: undefined,
  error: undefined,
  loading: true,
  loadingStartDate: true,
  societyType: '',
  source: 'SII',
  startDateActivity: ''
}

/**
 * The Legal Suitability Section reducer.
 */
const legalSuitabilityReducer = (state = legalSuitabilityState, { payload, type }) => {
  switch (type) {
    case GET_LEGAL_SUITABILITY: {
      return { ...state, loading: true }
    }
    case GET_LEGAL_SUITABILITY_SUCCESS: {
      return {
        ...state,
        loading: false,
        dni: payload.dni,
        societyType: payload.societyType,
        creationDate: payload.creationDate,
        source: payload.source
      }
    }
    case GET_LEGAL_SUITABILITY_ERROR: {
      return {
        ...state,
        loading: false,
        dni: payload.dni,
        error: payload.error
      }
    }
    case GET_START_DATE_ACTIVITY: {
      return { ...state, loadingStartDate: true }
    }
    case GET_START_DATE_ACTIVITY_SUCCESS: {
      return {
        ...state,
        loadingStartDate: false,
        startDateActivity: payload.startDateActivity
      }
    }
    case GET_START_DATE_ACTIVITY_ERROR: {
      return {
        ...state,
        loadingStartDate: false,
        error: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default legalSuitabilityReducer
